
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4oS56", function(module, exports) {

$parcel$export(module.exports, "EditorContextPanelContext", () => $a02892cdeb8a3601$export$be6a93f320014444);

var $gwFzn = parcelRequire("gwFzn");
const $a02892cdeb8a3601$export$be6a93f320014444 = (0, $gwFzn.createContext)({
    item: null,
    setItem: ()=>{},
    removeItem: ()=>{},
    editorAPI: undefined
});

});


//# sourceMappingURL=FullPageEditorComponent.ca305f11.js.map
